import { withInstall } from '@lit-element/utils'
import CheckTag from './src/check-tag.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtCheckTag: SFCWithInstall<typeof CheckTag> = withInstall(CheckTag)
export default LtCheckTag

export * from './src/check-tag'
